import card from './card/index';
import cardBar from './cardBar/index';
import navMenu from './navMenu/index';
export default {
    card,
    'card-bar':cardBar,
    'nav-menu':navMenu
}